module.exports = __webpack_public_path__ + "static/media/loc1_img3.7898eb7d.jpg";